import Router from './router/router';
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './App.css';
import { InteractionStatus, IPublicClientApplication } from '@azure/msal-browser';
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from './services/msalAuth/authConfig';
import { useDispatch } from "react-redux";
import { setLastUpdatedDate, setWindowSize } from "./services/redux/reducer/filter.reducer";
import { IPredectivePayload, IWindow } from './services/interface/IHome';
import { useInventoryAlerts } from './services/redux/hooks/useHome';
import "../src/utils/theme/_sizes.scss";

type AppProps = {
  pca: IPublicClientApplication
}

function App({ pca }: AppProps) {

  const dispatch = useDispatch();
  const [gbpPayload, setgbpPayload] = useState<IPredectivePayload>({
      adjustedLogic: [],
      alerts: [],
      clustername: [],
      futureSegmentation: [],
      l2: [],
      l3: [],
      material: [],
      materialDescription: [],
      mrpType: [],
      plant: [],
      poAlert: [],
      reviewedFlag: [],
      vendorName: [],
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [consentGiven, setConsentGiven] = useState(false);
  const [windowSize, setWindow] = useState<IWindow>({
    width: window.innerHeight,
    height: window.innerWidth
  });
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { mutate: mutateInventory, isError: isErrorInventory, error: errorInventory, isSuccess: isSuccessInventory, data: resInventory } = useInventoryAlerts();
  

  if (inProgress === InteractionStatus.None && !isAuthenticated) {
    localStorage.setItem('authHandler', '1')
    instance.loginRedirect(loginRequest)
      .catch((error: any) => {
        console.log(error)
      });
  }

  useEffect(() => {
    dispatch(setWindowSize(windowSize));
    // console.log(windowSize,);
  }, [windowSize]);

  //calling api to set lastUpdated Date
  useEffect(() => {
    const fetchAlerts = async () => {
        try {
            await mutateInventory(gbpPayload).unwrap();
        } catch (err) {
            console.error("Failed to fetch alerts: ", err);
        }
    };
    fetchAlerts();
  }, []);

  useEffect(() => {
    setLoading(true);
    if (resInventory && isSuccessInventory) {
        dispatch(setLastUpdatedDate(resInventory?.data?.lastUpdateDate))
        setLoading(false);
    }
}, [resInventory]);

  useEffect(() => {
    function handleResize() {
      setWindow({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
   
  useEffect(() => {

    const hasConsented = sessionStorage.getItem('cookieConsent');
    if (hasConsented) {
      setConsentGiven(true);
    } else {

      const script = document.createElement('script');
      script.id = "cookieWrapper";
      script.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
      script.charset = "UTF-8";
      script.setAttribute('data-domain-script', "cfe68b18-5bf6-4646-ab37-ec219d50a02f");
      script.innerHTML = `function OptanonWrapper() { }`;
      document.body.appendChild(script);

      sessionStorage.setItem('cookieConsent', 'true');
      setConsentGiven(true);
    }
  }, []);

  return (
    <div className='w-full h-[100vh] flex flex-nowrap'>
      <AuthenticatedTemplate>
        {!consentGiven && (
          <Helmet>
            <script
              id="cookieWrapper"
              src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
              charSet="UTF-8"
              data-domain-script="cfe68b18-5bf6-4646-ab37-ec219d50a02f"
            >
              function OptanonWrapper() { }
            </script>
          </Helmet>
        )}  
        <Router />
      </AuthenticatedTemplate>
    </div>
  );
}

export default App;
